import React, { useCallback, useMemo, useState } from "react";
import { Loading, MessageBanner, Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { hasAtLeastOneRole, useActiveRoles, } from "../../utils/permissionsUtils";
import { OutputsReportList } from "./OutputsReportList";
import { OUTPUT_REPORTS } from "./reportsConfig";
export var OutputsPage = function () {
    var _a, _b;
    var formatMessage = useIntl().formatMessage;
    var activeRoles = useActiveRoles();
    var _c = useState(null), requestedReportKey = _c[0], setRequestedReportKey = _c[1];
    var visibleReports = useMemo(function () {
        return activeRoles === undefined
            ? []
            : OUTPUT_REPORTS.filter(function (report) {
                return hasAtLeastOneRole(activeRoles, report.allowedRoles);
            });
    }, [activeRoles]);
    var selectedReport = (_a = visibleReports.find(function (report) { return report.key === requestedReportKey; })) !== null && _a !== void 0 ? _a : visibleReports[0];
    var handleSelect = useCallback(function (key) { return setRequestedReportKey(key); }, []);
    var renderContent = function () {
        if (activeRoles === undefined)
            return React.createElement(Loading, null);
        if (!selectedReport) {
            return (React.createElement(MessageBanner, { type: "warning" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.outputs.noReportsAvailable" })));
        }
        return React.createElement(selectedReport.Component, null);
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.pane.title.navigation",
            }) },
            React.createElement(NavComponent, null),
            visibleReports.length > 0 && (React.createElement(OutputsReportList, { reports: visibleReports, selectedKey: (_b = selectedReport === null || selectedReport === void 0 ? void 0 : selectedReport.key) !== null && _b !== void 0 ? _b : null, onSelect: handleSelect }))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.outputs.title",
            }) }, renderContent())));
};
